import { render, staticRenderFns } from "./questionPaper.vue?vue&type=template&id=5b8f2c1d&scoped=true"
import script from "./questionPaper.vue?vue&type=script&lang=js"
export * from "./questionPaper.vue?vue&type=script&lang=js"
import style0 from "./questionPaper.vue?vue&type=style&index=0&id=5b8f2c1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f2c1d",
  null
  
)

export default component.exports